/////////////////////////////FOR TESTING ONLY /////////////////////////////////////

//URL - ?arcadian-test-analytics=1
/**
 * Simple function to load analytics and GTM noscript with a 3-second delay
 */
function delayedAnalyticsLoad() {
  // Set a timeout to load analytics after 3 seconds
  setTimeout(function() {
    // Load analytics if the function exists
    if (typeof loadAnalytics === "function") {
      loadAnalytics();
    }
    
    // Add GTM noscript if the function exists
    if (typeof addGtmNoscript === "function") {
      addGtmNoscript();
    }
  }, 3000); // 3 seconds delay
}

//call function when url containes 'arcadian-test-analytics'
if (window.location.href.indexOf("arcadian-test-analytics") !== -1) {
  delayedAnalyticsLoad();
} 

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Configuration object - customise this per website
const COOKIE_CONSENT_CONFIG = {
  // Enable/disable specific cookie types
  enabledCategories: {
    necessary: true, // Always enabled
    functional: true, // Set to false to disable Functional Cookies
    analytics: true, // Set to false to disable Analytics Cookies
    marketing: true, // Set to false to disable Marketing Cookies
  },

  // Banner text
  bannerText:
    'We use cookies to personalise your experience on our website. By clicking "I Accept", you consent to our use of cookies. If you click "I Do Not Accept", cookies will not be used, but your experience may be affected. You can manage your cookie preferences through your browser settings. For more information, please refer to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',

  // Cookie descriptions - these will only show if the corresponding category is enabled
  cookieDescriptions: {
    necessary:
      "These cookies are required for the website to function and cannot be disabled.",
    functional: "These cookies enable personalized features and functionality.",
    analytics:
      "These cookies help us understand how visitors interact with our website.",
    marketing:
      "These cookies are used to deliver relevant ads and marketing campaigns.",
  },

  // Button text
  buttonText: {
    reject: "I Do Not Accept",
    accept: "I Accept",
  },

  // Cookie expiration in days
  cookieExpiration: 180,
  
  // WordPress cookies that should never be deleted
  wordpressCookies: [
    "wordpress_",
    "wordpress_logged_in_",
    "wordpress_test_cookie",
    "wp-settings-",
    "wp-settings-time-"
  ]
};

// Simple function to set a cookie
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

// Simple function to get a cookie
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return "";
}

// Save user's cookie choices
function saveCookieChoices(choices) {
  // Get current settings
  const currentSettings = JSON.parse(getCookie("cookie_consent_categories") || "{}");
  
  // Check if analytics was toggled ON
  const analyticsToggled = 
    choices.analytics === true && 
    (!currentSettings.hasOwnProperty("analytics") || currentSettings.analytics === false);
  
  // Save using the configured expiration days
  setCookie(
    "cookie_consent_categories",
    JSON.stringify(choices),
    COOKIE_CONSENT_CONFIG.cookieExpiration
  );
  
  // Return whether analytics was toggled
  return analyticsToggled;
}

// Apply cookie settings based on user choices
function applyCookieSettings(settings) {
  // First handle cookie removal for rejected categories
  removeRejectedCookies(settings);
  
  // Then load scripts for accepted categories
  if (settings.functional && typeof loadFunctionalScripts === "function") {
    loadFunctionalScripts();
  }

  if (settings.analytics && typeof loadAnalytics === "function") {
    loadAnalytics();
    addGtmNoscript();
  }


  
  if (settings.marketing && typeof loadMarketingScripts === "function") {
    loadMarketingScripts();
  }
}

// Common cookies by category - add site-specific cookies as needed
const commonCookiesByCategory = {
  functional: ["CLID", "preferences", "settings"],
  analytics: [
    "_ga", "_gid", "_gat", "_gali", "_ga_", // GA cookies with prefixes
    "NID", "VISITOR_INFO1_LIVE", "YSC", "VISITOR_PRIVACY_METADATA"
  ],
  marketing: [
    "_fbp", "fr", "_fbc", // Facebook
    "IDE", "DSID", "MUID", "_clck", "_clsk" // Other marketing cookies
  ]
};

// Remove cookies for categories the user has rejected
function removeRejectedCookies(settings) {
  // Check which categories to remove cookies for
  if (COOKIE_CONSENT_CONFIG.enabledCategories.functional && !settings.functional) {
    removeCookiesByCategory('functional');
  }
  
  if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics && !settings.analytics) {
    removeCookiesByCategory('analytics');
  }
  
  if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing && !settings.marketing) {
    removeCookiesByCategory('marketing');
  }
}

// Remove cookies for a specific category
function removeCookiesByCategory(category) {
  const cookies = commonCookiesByCategory[category] || [];
  
  cookies.forEach(cookieName => {
    // For cookies with prefixes (like _ga_), find and remove all matches
    if (cookieName.endsWith('_')) {
      const allCookies = document.cookie.split(';');
      allCookies.forEach(cookie => {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith(cookieName)) {
          const name = trimmedCookie.split('=')[0];
          removeCookie(name);
        }
      });
    } else {
      // For exact cookie names
      removeCookie(cookieName);
    }
  });
}

// Targeted cookie removal function
function removeCookie(name) {
  // Skip WordPress cookies
  for (const wpCookie of COOKIE_CONSENT_CONFIG.wordpressCookies) {
    if (name.startsWith(wpCookie)) {
      return;
    }
  }
  
  // Standard cookie removal approach - works for most cookies
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`;
  
  // For cookies that might be set with specific domain
  const domain = window.location.hostname;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${domain};`;
  
  // For cookies that might be set on the root domain
  if (domain.includes('.')) {
    const rootDomain = domain.substring(domain.indexOf('.'));
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=${rootDomain};`;
  }
}

// Create cookie consent modal
function showCookieModal() {
  const modal = document.createElement("div");
  modal.id = "cookie-consent-modal";

  // Get existing settings or defaults
  const savedConsent = JSON.parse(
    getCookie("cookie_consent_categories") || "{}"
  );

  // Build HTML for info sections
  let cookieInfoHtml = `
    <div class="cookie-category">
      <div class="cookie-category-header">
        <h4>Necessary Cookies</h4>
      </div>
      <p>${COOKIE_CONSENT_CONFIG.cookieDescriptions.necessary}</p>
    </div>
  `;

  if (COOKIE_CONSENT_CONFIG.enabledCategories.functional) {
    cookieInfoHtml += `
      <div class="cookie-category">
        <div class="cookie-category-header">
          <h4>Functional Cookies</h4>
        </div>
        <p>${COOKIE_CONSENT_CONFIG.cookieDescriptions.functional}</p>
      </div>
    `;
  }

  if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics) {
    cookieInfoHtml += `
      <div class="cookie-category">
        <div class="cookie-category-header">
          <h4>Analytics Cookies</h4>
        </div>
        <p>${COOKIE_CONSENT_CONFIG.cookieDescriptions.analytics}</p>
      </div>
    `;
  }

  if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing) {
    cookieInfoHtml += `
      <div class="cookie-category">
        <div class="cookie-category-header">
          <h4>Marketing Cookies</h4>
        </div>
        <p>${COOKIE_CONSENT_CONFIG.cookieDescriptions.marketing}</p>
      </div>
    `;
  }

  modal.innerHTML = `
    <div class="cookie-modal-content">
      <div class="cookie-modal-header">
        <h3>Cookie Preferences</h3>
        <button id="cookie-modal-close">×</button>
      </div>
      <div class="cookie-modal-body">
        <p>We use cookies to personalise your experience on our website. By clicking "I Accept", you consent to our use of cookies. If you click "I Do Not Accept", cookies will not be used, but your experience may be affected. You can manage your cookie preferences through your browser settings. For more information, please refer to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</p>
        
        ${cookieInfoHtml}
      </div>
      <div class="cookie-modal-footer">
        <button id="cookie-reject-modal">${COOKIE_CONSENT_CONFIG.buttonText.reject}</button>
        <button id="cookie-accept-modal">${COOKIE_CONSENT_CONFIG.buttonText.accept}</button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Add event listeners
  document
    .getElementById("cookie-modal-close")
    .addEventListener("click", function () {
      modal.remove();
      
      // Check if cookie consent already exists
      const savedConsent = JSON.parse(
        getCookie("cookie_consent_categories") || "{}"
      );
      
      // Only show banner if no consent exists
      if (Object.keys(savedConsent).length === 0) {
        createCookieBanner();
      }
    });

  document
    .getElementById("cookie-accept-modal")
    .addEventListener("click", function () {
      const allConsent = { necessary: true };

      if (COOKIE_CONSENT_CONFIG.enabledCategories.functional) {
        allConsent.functional = true;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics) {
        allConsent.analytics = true;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing) {
        allConsent.marketing = true;
      }

      // Save preferences
      saveCookieChoices(allConsent);
      
      // Apply settings
      applyCookieSettings(allConsent);
      
      // Remove the modal
      modal.remove();
    });

  document
    .getElementById("cookie-reject-modal")
    .addEventListener("click", function () {
      const minimalConsent = { necessary: true };

      if (COOKIE_CONSENT_CONFIG.enabledCategories.functional) {
        minimalConsent.functional = false;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics) {
        minimalConsent.analytics = false;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing) {
        minimalConsent.marketing = false;
      }

      saveCookieChoices(minimalConsent);
      // Apply settings first
      applyCookieSettings(minimalConsent);
      modal.remove();
      
      // Reload the page to ensure all cookie changes take effect
      window.location.reload();
    });
}

// Create cookie consent banner
function createCookieBanner() {
  const banner = document.createElement("div");
  banner.id = "cookie-consent-banner";

  let buttonHtml = `
    <button id="cookie-reject-all">${COOKIE_CONSENT_CONFIG.buttonText.reject}</button>
    <button id="cookie-accept-all">${COOKIE_CONSENT_CONFIG.buttonText.accept}</button>
  `;

  banner.innerHTML = `
  <div class="cookie-consent-content container">
    <div class="cookie-consent-text">
      <p>${COOKIE_CONSENT_CONFIG.bannerText}</p>
    </div>
    <div class="cookie-consent-buttons">
      ${buttonHtml}
    </div>
  </div>
  `;

  document.body.appendChild(banner);

  // Add event listeners
  document
    .getElementById("cookie-accept-all")
    .addEventListener("click", function () {
      const allConsent = { necessary: true };

      if (COOKIE_CONSENT_CONFIG.enabledCategories.functional) {
        allConsent.functional = true;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics) {
        allConsent.analytics = true;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing) {
        allConsent.marketing = true;
      }

      // Save preferences
      saveCookieChoices(allConsent);
      
      // Apply settings
      applyCookieSettings(allConsent);
      
      // Remove the banner without reloading
      banner.remove();
    });

  document
    .getElementById("cookie-reject-all")
    .addEventListener("click", function () {
      const minimalConsent = { necessary: true };

      if (COOKIE_CONSENT_CONFIG.enabledCategories.functional) {
        minimalConsent.functional = false;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.analytics) {
        minimalConsent.analytics = false;
      }
      if (COOKIE_CONSENT_CONFIG.enabledCategories.marketing) {
        minimalConsent.marketing = false;
      }

      saveCookieChoices(minimalConsent);
      applyCookieSettings(minimalConsent);
      banner.remove();
    });
}

// Initialize cookie consent
function initCookieConsent() {
  const savedConsent = JSON.parse(
    getCookie("cookie_consent_categories") || "{}"
  );

  // If consent exists, apply settings and don't show banner
  if (Object.keys(savedConsent).length > 0) {
    applyCookieSettings(savedConsent);
    return;
  }

  // Create and show the banner
  createCookieBanner();
}

// Add "Manage Cookies" button
function addManageCookiesButton() {
  const footer = document.querySelector("footer") || document.body;
  
  const buttonWrapper = document.createElement("div");
  buttonWrapper.className = "manage-cookies-wrapper container";
  
  const manageCookiesBtn = document.createElement("button");
  manageCookiesBtn.id = "manage-cookies-btn";
  manageCookiesBtn.innerText = "Manage Cookie Preferences";
  manageCookiesBtn.className = "manage-cookies-button";

  manageCookiesBtn.addEventListener("click", function () {
    if (document.getElementById("cookie-consent-banner")) {
      document.getElementById("cookie-consent-banner").remove();
    }
    showCookieModal();
  });

  buttonWrapper.appendChild(manageCookiesBtn);
  footer.appendChild(buttonWrapper);
}

// Run when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  // Only run on production or when testing
  if (!document.body.classList.contains("production-environment")) {
    return;
  }

  // Only run if .display-cookie-banner exists
  if (!document.querySelector('.display-cookie-banner')) {
    return;
  }

  // Initialize consent banner
  initCookieConsent();
});

// Add manage cookies button
setTimeout(function() {
  // Only add manage cookies button if .display-cookie-banner exists
  if (document.querySelector('.display-cookie-banner')) {
    addManageCookiesButton();
  }
}, 1000);


function addGtmNoscript() {
  // Only add if not already present
  if (!document.querySelector('iframe[src*="googletagmanager.com/ns.html"]')) {
    // Create container for the noscript tag
    const container = document.createElement('div');
    container.innerHTML = '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NM57G63" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>';
    
    // Add to beginning of body
    if (document.body.firstChild) {
      document.body.insertBefore(container, document.body.firstChild);
    } else {
      document.body.appendChild(container);
    }
  }
}